import React from "react";

import { Button } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import {
  withTrackEvent,
  objectTypes,
  actionNames,
  actionPrefixes,
} from "@newsela/snitch";
import ChallengesHeader from "@/challenges/ChallengesFolder/ChallengesHeader";
import ChallengesListSectionContainer from "@/challenges/ChallengesFolder/ChallengesListSectionContainer";
import {
  buttonContainer,
  buttonsWrapper,
  folderContentsHeader,
  folderContentsWrapper,
  ViewChallengesButton,
} from "./FolderContents.style";

const propTypes = {
  isHomeVersion: PropTypes.bool,
  isTeacher: PropTypes.bool,
  activeData: PropTypes.object,
};

const FolderContents = ({ isHomeVersion, isTeacher = false, activeData }) => {
  const ButtonWithTrackEvent = withTrackEvent(Button);
  const isTeacherChallengePage = !isHomeVersion && isTeacher;
  const router = useRouter();
  const eventProperties = {
    objectType: objectTypes.user,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.navigate,
    streamProperties: {
      component_type: "FolderContents",
      description: "Redirect user to challenge page",
    },
  };

  const handleTitle = () => {
    switch (activeData?.subject) {
      case "Science":
        return "Take a look around";
      case "SEL":
        return "Learn something new";
      case "Social Studies":
        return "Dig in deeper";
      default:
        return "Choose your adventure";
    }
  };

  if (!activeData) {
    return null;
  }
  return (
    <div css={folderContentsWrapper}>
      <div css={folderContentsHeader(isTeacherChallengePage)}>
        <ChallengesHeader
          description={activeData?.description}
          heading={handleTitle()}
          subheading={isTeacher ? "" : "Challenge Details"}
          activeBreadcrumbs={false}
          challengeId={activeData?.challenge_id}
          isHomeVersion={isHomeVersion}
        />
      </div>
      <ChallengesListSectionContainer
        isHomeVersion={isHomeVersion}
        longVersion
        topics={activeData?.topics}
      />
      {isHomeVersion && isTeacher && (
        <div
          css={buttonsWrapper}
          data-qa-selector="IRC: Redirect to Challenge Page"
        >
          <div css={buttonContainer}>
            <ButtonWithTrackEvent
              id="viewChallenge"
              {...eventProperties}
              __cssFor={{ root: ViewChallengesButton }}
              flavor={Button.flavors.primary}
              size={Button.sizes.lg}
              onClick={() => router.push("/challenges")}
              dataProps={{
                "data-qa-selector": "IRC: Redirect to Challenge Page",
              }}
            >
              View challenge
            </ButtonWithTrackEvent>
          </div>
        </div>
      )}
    </div>
  );
};

FolderContents.propTypes = propTypes;

export default FolderContents;
